import React from 'react'
import './Orderdetail.css'
import { useNavigate } from 'react-router-dom';
const Orderdetail = () => {
   const navigate = useNavigate();
  return (
    <> <div className="orderDetailColumn_three">
    <div className="rowthumbsup_one">
      <div className="column_two">
        <div className="column_one-1">
          <div className="orderDetailColumn-1">
            <div className="columnthumbsup">
              <img src="" alt="Image" className="image" />
              <button className="thumbsup_one ui button gray_900 size-xs fill circle">
                <img src="" />
              </button>
            </div>
          </div>
          <div className="columnrayandipb">
            <h1 className="rayandipbiswas ui heading size-headinglg">
              Rayandip Biswas
            </h1>
            <div className="rowemail">
              <p className="email ui text size-textxs">rayandip.ui@gmail.com</p>
              <div className="row91983214027">
                <p className="class-91983214027 ui text size-textxs">
                  +91 983214027
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="columnmyorders">
          <div className="rowmyorders">
            <p className="myorders ui text size-textmd">My Orders</p>
            <img src="" alt="Arrowright" className="arrowright_one" />
          </div>
          <div className="rowmyaddress">
            <p className="myorders ui text size-textmd">My Address</p>
            <img src="" alt="Arrowright" className="arrowright_one" />
          </div>
          <div className="rowmyaddress">
            <p className="myorders ui text size-textmd">Wishlist</p>
            <img src="" alt="Arrowright" className="arrowright_one" />
          </div>
          <div className="rowmyaddress">
            <p className="myorders ui text size-textmd">Logout</p>
            <img src="" alt="Arrowright" className="arrowright_one" />
          </div>
        </div>
      </div>
      <div className="columnyourorder">
        <h2 className="yourorders ui heading size-heading2xl">Your Orders</h2>
        <div className="listorderplaced">
          <div className="columnorderplac">
            <div className="roworder404">
              <div className="roworderplaced">
                <div className="columnenterotp">
                  <p className="order404 ui text size-text3xl">ORDER PLACED</p>
                  <p className="order404 ui text size-text3xl">2 December 2024</p>
                </div>
                <div className="columntotal">
                  <p className="order404 ui text size-text3xl">TOTAL</p>
                  <p className="order404 ui text size-text3xl">₹683.00</p>
                </div>
              </div>
              <div className="columnorder404">
                <p className="order404 ui text size-text3xl">
                  ORDER# 404-2589865-989806
                </p>
                <div className="rowview_order">
                  <p className="view_order ui text size-text3xl">
                    View order details
                  </p>
                  <div className="row91983214027">
                    <p className="invoice ui text size-text3xl">Invoice</p>
                    <img src="" alt="Invoice" className="arrowright_one" />
                  </div>
                </div>
              </div>
            </div>
            <div className="row2_december">
              <img
                src=""
                alt="2 December 2024"
                className="class-2_december_2024"
              />
              <div className="columnindiannee">
                <div className="columnindiannee-3">
                  <h3 className="indianneedle ui heading size-headingmd">
                    Indian Needle.
                  </h3>
                  <p className="order404 ui text size-text3xl">
                    Grey Geometric Textured Corduroy Shirt...
                  </p>
                </div>
                <p className="order404 ui text size-text3xl">
                  <span>Delivered by&nbsp;</span>
                  <span className="deliveredbytwo-span">2 Dec 2024</span>
                </p>
              </div>
            </div>
          </div>
          <div className="columnorderplac">
            <div className="roworder404">
              <div className="roworderplaced">
                <div className="columnenterotp">
                  <p className="order404 ui text size-text3xl">ORDER PLACED</p>
                  <p className="order404 ui text size-text3xl">2 December 2024</p>
                </div>
                <div className="columntotal">
                  <p className="order404 ui text size-text3xl">TOTAL</p>
                  <p className="order404 ui text size-text3xl">₹683.00</p>
                </div>
              </div>
              <div className="columnorder404">
                <p className="order404 ui text size-text3xl">
                  ORDER# 404-2589865-989806
                </p>
                <div className="rowview_order">
                  <p className="view_order ui text size-text3xl">
                    View order details
                  </p>
                  <div className="row91983214027">
                    <p className="invoice ui text size-text3xl">Invoice</p>
                    <img src="" alt="Invoice" className="arrowright_one" />
                  </div>
                </div>
              </div>
            </div>
            <div className="row2_december">
              <img
                src=""
                alt="2 December 2024"
                className="class-2_december_2024"
              />
              <div className="columnindiannee">
                <div className="columnindiannee-3">
                  <h4 className="indianneedle ui heading size-headingmd">
                    Indian Needle.
                  </h4>
                  <p className="order404 ui text size-text3xl">
                    Grey Geometric Textured Corduroy Shirt...
                  </p>
                </div>
                <p className="order404 ui text size-text3xl">
                  <span>Delivered by&nbsp;</span>
                  <span className="deliveredbytwo-span">2 Dec 2024</span>
                </p>
              </div>
            </div>
          </div>
          <div className="columnorderplac">
            <div className="roworder404">
              <div className="roworderplaced">
                <div className="columnenterotp">
                  <p className="order404 ui text size-text3xl">ORDER PLACED</p>
                  <p className="order404 ui text size-text3xl">2 December 2024</p>
                </div>
                <div className="columntotal">
                  <p className="order404 ui text size-text3xl">
                    ORDER# 404-2589865-989806
                  </p>
                  <p className="order404 ui text size-text3xl">₹683.00</p>
                </div>
              </div>
              <div className="columnorder404">
                <p className="order404 ui text size-text3xl">
                  ORDER# 404-2589865-989806
                </p>
                <div className="rowview_order">
                  <p className="view_order ui text size-text3xl">
                    View order details
                  </p>
                  <div className="row91983214027">
                    <p className="invoice ui text size-text3xl">Invoice</p>
                    <img src="" alt="Invoice" className="arrowright_one" />
                  </div>
                </div>
              </div>
            </div>
            <div className="row2_december">
              <img
                src=""
                alt="2 December 2024"
                className="class-2_december_2024"
              />
              <div className="columnindiannee">
                <div className="columnindiannee-3">
                  <h5 className="indianneedle ui heading size-headingmd">
                    Packed
                  </h5>
                  <p className="order404 ui text size-text3xl">
                    Grey Geometric Textured Corduroy Shirt...
                  </p>
                </div>
                <p className="order404 ui text size-text3xl">
                  <span>Delivered by&nbsp;</span>
                  <span className="deliveredbytwo-span">2 Dec 2024</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </>
  )
}

export default Orderdetail